import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-184">
      <div className="max-w-3xl mx-auto text-center" data-id="element-185">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-186">
          Si sos docente de Música en primaria o secundaria,
          <br data-id="element-187" />
          <span className="text-[#FFD700]" data-id="element-188">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-189">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-190">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-191">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-192">
              Domingo a la noche buscando material que nunca queda bien
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-193">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-194">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-195">
              Clases improvisadas porque no tenés guion ni estructura
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-196">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-197">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-198">
              Actos a las corridas sin ensayo real ni propuesta clara
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-199">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-200">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-201">
              Evaluaciones inventadas porque no tenés criterios listos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-202">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-203">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-204">
              Horas perdidas que nunca recuperás
            </p>
          </div>
        </div>

        <p className="text-[#FFD700] text-2xl sm:text-3xl font-black mb-8" data-id="element-205">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Gold divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FFD700] to-transparent w-full" data-id="element-206" />
      </div>
    </section>;
}